<template>
  <div
    class="relative vh-100 flex flex-column items-stretch justify-between"
  >
    <BgLeaves
      v-if="development.brand === 'lh'"
      :trigger="leaves"
      :position="[1, 0, 1, 0]"
      :inset="10"
    />
    <SliderArrows
      ref="sliderArrows"
      :brand="development.brand"
    />
    <transition-group
      @enter="animEnterSlider"
      @leave="animLeaveSlider"
      mode="out-in"
      :css="false"
      tag="div"
      class="relative bg-light"
      style="z-index: 999; mix-blend-mode: color-burn; flex-grow: 1;"
    >
      <Floorplan
        v-touch:swipe.left="swipeLeft"
        v-touch:swipe.right="swipeRight"
        ref="floorplans"
        v-for="(item, index) in houseStyle.floorplans"
        v-show="activeTab === index"
        :key="index"
        :brand="development.brand"
        :content="item"
        :markers="item.markers"
      />
    </transition-group>
    <NavSecondary
      :brand="development.brand"
      :icon="icon"
      :items="nav"
      title="Floorplans"
    />
  </div>
</template>

<script>
import Floorplan from '@/components/property/Floorplan'
import NavSecondary from '@/components/property/NavSecondary'
import SliderArrows from '@/components/property/SliderArrows.vue'
import BgLeaves from '@/components/BgLeaves.vue'

import transitions from '../../transitions.js'

export default {
  name: 'Floorplans',
  components: {
    Floorplan,
    NavSecondary,
    SliderArrows,
    BgLeaves
  },
  props: {
    development: {
      type: Object,
      default: null
    },
    plot: {
      type: Object,
      default: null
    },
    houseStyle: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      icon: require('@/assets/img/icon-floorplans.svg'),
      navTab: [],
      leaves: false
    }
  },
  computed: {
    activeTab () {
      return this.$store.state.activeTab
    },
    prevTab () {
      return this.$store.state.prevTab
    },
    nav () {
      const nav = []
      this.houseStyle.floorplans.forEach(element => {
        nav.push(element.caption)
      })
      return nav
    }
  },
  mounted () {
    this.$store.commit('setFloorPlanLength', this.houseStyle.floorplans.length)
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.leaves = true
    })
  },
  beforeRouteLeave (to, from, next) {
    this.leaves = false
    setTimeout(() => {
      next()
    }, 200)
  },
  methods: {
    swipeLeft () {
      this.$refs.sliderArrows.next()
    },
    swipeRight () {
      this.$refs.sliderArrows.previous()
    },
    animEnterSlider (el, done) {
      if (this.activeTab > this.prevTab) {
        transitions.fadeInRight(el, done)
      } else {
        transitions.fadeInLeft(el, done)
      }
    },
    animLeaveSlider (el, done) {
      if (this.activeTab > this.prevTab) {
        transitions.fadeOutLeft(el, done)
      } else {
        transitions.fadeOutRight(el, done)
      }
    }
  }
}
</script>
